import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Dispatch } from 'redux'
import LocationActions from 'actions/Location'
import SectorActions from 'actions/Sector'
import { RootReducerState } from 'types/global'
import { LocationAction, LocationReducer } from 'types/location'
import { SectorAction, SectorReducer } from 'types/sector'
import { useFilterClear } from 'hooks/useFilterClear'

export const useUnitySectors = () => {
  const { id } = useParams()
  const [searchSector, setSearchSector] = useState('')
  const [searchStatus, setSearchStatus] = useState('')
  const [sectorOrder, setSectorOrder] = useState<any>({ field: 'u_name', order: 'ORDERBY' })

  const sectorDispatch: Dispatch<SectorAction> = useDispatch()
  const sectorSelector: SectorReducer = useSelector((state: RootReducerState) => state.sectorReducers)
  const locationSelector: LocationReducer = useSelector((state: RootReducerState) => state.locationReducers)
  const locationDispatch: Dispatch<LocationAction> = useDispatch()
  

  useFilterClear({
    inputId: 'input-text-setor',
    filterValue: searchSector,
    setFilterValue: setSearchSector
  })

 
  useEffect(() => {
    // Resetar lista quando ordenação muda
    if (sectorOrder) {
      SectorActions.getAllSectorsByLocationId(
        sectorDispatch, 
        id, 
        searchSector?.normalize('NFD').replace(/\p{M}/gu, '') ?? "", 
        searchStatus ?? "",
        sectorOrder
      )
    }
  }, [searchSector, searchStatus, id, sectorDispatch, sectorOrder])

  useEffect(() => {
    if (id) {
      LocationActions.getById(locationDispatch, id)
    }
  }, [id, locationDispatch])


  const getStatus = (value: string) => {
    switch (value) {
      case "Ativo":
        return "true"
      case "Inativo":
        return "false"
      case "Todos":
        return ""
      default:
        return ""
    }
  }

  return {
    searchSector,
    setSearchSector,
    searchStatus,
    setSearchStatus,
    sectorSelector,
    locationSelector,
    sectorDispatch,
    getStatus,
    sectorOrder,
    setSectorOrder
  }
}